import $ from "jquery";
import load from '@pandasekh/dynamic-script-loader';
import dayjs from "dayjs";
import { checkNested, getPageUrl } from "#scripts/general_functions";
import language from "#scripts/translation";
import "@prokomssp/edoc-viewer/prod/duet/themes/default.css";
import "@prokomssp/edoc-viewer/prod/viewer.min.css";
import { render } from "lit";

export const skjemaOverview = (viewer) => {
	$("#maincontent").html(`<div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container" id="formcontainer">
                        </div>
                    </div>
                </div>
            </div>`);

	$("#formcontainer").html(`    
						<div class="list__header">      
							<h1>Hei ${user.firstName}</h1>
							<a class="float-right" href="/skjema/logout">Logg ut</a>
							<p>Her finner du en oversikt over dine lagrede skjema.</p>
						</div>
						<div id="myforms">loading...</div>`);

	viewer.getCases().then((cases) => {
		let forms = [];
		const formHtml = (form, saved = false) => {
			let url = `/skjema/pdf/${form.refId}`;
			if (saved) url = `/skjema/open/${form.refId}`;

			return `<tr id="caseline_${form.refId}">
									<td><a href="/skjema/open/${form.refId}">${form.name}</a></td>
									<td>${form.updatedOn}</td>
									<td>${saved ? "Lagret" : "Innsendt"}</td>
									<td><button class="btn btn-danger deleteForm " data-id="${form.refId}">Slett</button></td>
							</tr>`;
		};

		cases.num = cases.saved.length + cases.submitted.length;
		for (const form of cases.saved) {
			forms.push(formHtml(form, true));
		}

		for (const form of cases.submitted) {
			forms.push(formHtml(form));
		}
		forms = forms.join("");
		let r = "";

		if (cases.num) {
			r = `<table class="table">
								<thead>
										<tr>
												<th>Skjema</th>
												<th>Lagret</th>
												<th colspan=2>Status</th>
										</tr>
								</thead>
								<tbody>
										${forms}
								</tbody>
						</table>`;
		} else {
			r = `<p>
							Du har ingen lagrede eller innsendte skjema å vise. Gå til <a href="/skjema/alle">skjemaoversikten</a> for å legge inn et nytt skjema.
					</p>`;
		}

		$("#myforms").html(r);

		$(".deleteForm").click(function () {
			const id = $(this).data("id");
			viewer.deleteCase(id);

			$(`#caseline_${id}`).remove();
		});
	});
};

export const skjemaOverview2 = (viewer) => {
	const r = `<div class="container">
				<div class="row justify-content-sm-center">
						<div class="col-sm-9 p-0">
								<div class="form__container" id="formcontainer">
								</div>
						</div>
				</div>
		</div>`;

	$("#maincontent").html(r);

	$("#formcontainer").html(`
			<div class="list__header"> 
				<h1>Hei ${window.user?.firstName}</h1>
				<p>${language("FORM_MYFORMS_DESCRIPTION")}</p>
			</div>
			<div id="myforms" class="list__container"></div>
			<div id="allforms" class="list__container"></div>
	`);

	viewer.getCases().then((cases) => renderCases(cases));
	viewer.getCategories().then((forms) => renderAllForms(forms));
	const renderCases = (cases) => {
		let forms = [];
		const formHtml = (form, saved = false) => {
			let url = `/skjema/pdf/${form.refId}`;
			if (saved) url = `/skjema/open/${form.refId}`;
			let icons = saved ? `<div class="icon"><span class="pill">Påbegynt</span><span class="material-icons-outlined deleteForm" data-id="${form.refId}">delete</span></div>` : "";
			return `<div class="item" id="caseline_${form.refId}">
							<div>
								<div class="title">
									<a href="/skjema/open/${form.refId}">${form.name}</a>
								</div>
								<div class="date">
									Lagret ${dayjs(form.updatedOn).format("DD MMM YYYY - HH:mm")}
								</div>	
							</div>
							${icons}
						</div>
            `;
		};

		cases.num = cases.saved.length + cases.submitted.length;
		forms = cases.saved.map(form => formHtml(form, true)).concat(cases.submitted.map(form => formHtml(form))).join("");

		const tableHtml = cases.num ? `
						<h2>${language("FORM_MYFORMS")}</h2>
            <div class="list__items">
                    ${forms}
            </div>
        ` : `
            <span class="list__empty">
                Du har ingen påbegynte skjemaer
            </span>
        `;

		$("#myforms").html(tableHtml);

		$(".deleteForm").click(function () {
			const id = $(this).data("id");
			viewer.deleteCase(id);
			$(`#caseline_${id}`).remove();
		});
	};
	const renderAllForms = (forms) => {
		let allforms = [];
		for (const category of forms.categories) {
			allforms.push(`<details><summary><span class="material-icons-outlined"></span>${category.caption}</summary>`);
			for (const template of category.templates) {
				allforms.push(`<p><a href="/skjema/${template.formId}"><span class="material-icons-outlined">assignment</span>${template.name}</a></p>`);
			}
			allforms.push(`</details>`);
		}

		allforms = allforms.join("");
		const r = `
						<h2>${language("FORM_ALLFORMS")}</h2>
            <div class="list__items">
                    ${allforms}
            </div>`;

		$("#allforms").html(r);
	}
};

export const skjemaSubmitted = (viewer) => {

}
export const skjemaLogoutConfirmation = () => {
	const r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container">
                            <h1>Du er logget ut</h1>
                            <p>Du er nå logget ut av siden. For å se dine saker kan du logge inn igjen på <a href="${window.serverdata.configMeta.aim?.mysite?.forms?.skjema ? `${window.serverdata.configMeta.aim?.mysite?.link}?page=forms` : "/skjema / mine"}">mine skjema</a></p>
                            <p>Gå til <a href="/">forsiden</a></p>
                        </div>
                    </div>
                </div>
            </div>`;

	$("#maincontent").html(r);
};

export const skjemaLogin = (viewer, returnurl) => {
	let triedLoop = 0;
	if (sessionStorage.getItem("loginLoops")) {
		triedLoop = sessionStorage.getItem("loginLoops");
	}
	if (triedLoop < 1) {
		sessionStorage.setItem("loginLoops", triedLoop + 1);
		viewer.logIn({
			securityLevel: 3,
			returnUrl: returnurl,
		});
	} else {
		let clientname = window.serverdata.configMeta.aim.nameId;

		if (window.serverdata.configMeta.aim.skjema) {
			if (window.serverdata.configMeta.aim.skjema.id) {
				clientname = window.serverdata.configMeta.aim.skjema.id;
			}
		}

		setTimeout(() => {
			$("#formcontainer").prepend(`
            <p>
							${language("FORM_LOGIN_FAILED")}
            </p>
        `);
		}, 1500);
	}
};

export const skjemaLogout = (viewer) => {
	sessionStorage.removeItem("loginLoops");
	viewer.logOut(`${location.origin}/skjema/logoutconfirmation`);
};

export const skjemaAll = (viewer) => {
	const renderCases = (cases) => {
		let forms = [];
		const formHtml = (form, saved = false) => {
			let url = `/skjema/pdf/${form.refId}`;
			if (saved) url = `/skjema/open/${form.refId}`;

			return `
                <tr id="caseline_${form.refId}">
                    <td><a href="/skjema/open/${form.refId}">${form.name}</a></td>
                    <td>${form.updatedOn}</td>
                    <td>${saved ? "Lagret" : "Innsendt"}</td>
                    <td><button class="btn btn-danger deleteForm" data-id="${form.refId}">Slett</button></td>
                </tr>
            `;
		};

		cases.num = cases.saved.length + cases.submitted.length;
		forms = cases.saved.map(form => formHtml(form, true)).concat(cases.submitted.map(form => formHtml(form))).join("");

		const tableHtml = cases.num ? `
            <table class="table">
                <thead>
                    <tr>
                        <th>Skjema</th>
                        <th>Lagret</th>
                        <th colspan=2>Status</th>
                    </tr>
                </thead>
                <tbody>
                    ${forms}
                </tbody>
            </table>
        ` : `
            <p>
                Du har ingen lagrede eller innsendte skjema å vise. Gå til <a href="/skjema/alle">skjemaoversikten</a> for å legge inn et nytt skjema.
            </p>
        `;

		$("#myforms").html(tableHtml);

		$(".deleteForm").click(function () {
			const id = $(this).data("id");
			viewer.deleteCase(id);
			$(`#caseline_${id}`).remove();
		});
	};
	viewer.getCases().then((cases) => renderCases(cases));
	viewer.getCategories().then((forms) => {
		let allforms = [];
		for (const category of forms.categories) {
			allforms.push(`<details><summary><span class="                                                                                                  material-icons-outlined"></span>${category.caption}</summary>`);
			for (const template of category.templates) {
				allforms.push(`<p><a href="/skjema/${template.formId}">${template.name}</a></p>`);
			}
			allforms.push(`</details>`);
		}

		allforms = allforms.join("");
		const r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container">
                            <div id="skjema_page">
                                <h1>${language("FORM_ALLFORMS")}</h1>
                                <p>${language("FORM_ALLFORMS_DESCRIPTION")}</p>
																<div id="myforms"></div>
                                ${allforms}
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

		$("#maincontent").html(r);
	});
};

export const skjemaPage = () => {
	const formid = getPageUrl().contentid;
	const r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-12 p-0">
                        <div class="form__container" id="formcontainer">
                            <div id="skjema_page"></div>
                        </div>
                    </div>
                </div>
            </div>`;

	$("#maincontent").html(r);

	let id = window.serverdata.configMeta.aim.nameId;

	if (checkNested(window.serverdata.configMeta.aim, "skjema", "id")) {
		id = window.serverdata.configMeta.aim.skjema.id;
	}

	// console.log("id skjema", id);
	// load('/edoc/viewer.min.js').then((element) => {
	Promise.all([
		load('/edoc/duet/duet.js'),
		load('/edoc/viewer.min.js')
	])
		.then(() => {
			// Ensure the viewer script is fully loaded before initializing
			const viewerScript = document.querySelector('script[src="/edoc/viewer.min.js"]');
			viewerScript.addEventListener('load', async () => {
				let clientname = window.serverdata.configMeta.aim.nameId;

				if (window.serverdata.configMeta.aim.skjema) {
					if (window.serverdata.configMeta.aim.skjema.id) {
						clientname = window.serverdata.configMeta.aim.skjema.id;
					}
				}
				const skjemaApiUrl = window.serverdata.configMeta.aim?.skjema?.apiUrl ? window.serverdata.configMeta.aim?.skjema?.apiUrl : "https://api.skjema.no";
				viewer.init({
					apiUrl: skjemaApiUrl,
					// apiUrl: "/api/skjema",
					// apiUrl: "https://api.skjema.no",
					customerId: clientname,
					skipReadAndAcceptedPrivacy: true,
				});

				if (formid === "logout") {
					return skjemaLogout(viewer);
				}

				if (formid === "logoutconfirmation") {
					return skjemaLogoutConfirmation();
				}

				if (formid === "" || formid === "alle") {
					return skjemaAll(viewer);
					// testlogin(user, viewer);
					// return skjemaOverview2(viewer);
				}

				const testlogin = (user, viewer) => {
					// finne ut om skjema trenger pålogging.

					window.user = user;

					if (!user) {
						//     if (!sessionStorage.getItem("userLoop")) {
						skjemaLogin(viewer, location.href);
						//     }
					}
				};

				const user = await viewer.getAuthenticatedUser();
				// testlogin(user, viewer);

				if (formid.match(/open/gim)) {
					testlogin(user, viewer);
					const open = formid.split("/");
					loadFrom("skjema_page", 0, open[1]);
					return;
				}

				if (formid.match(/pdf/gim)) {
					const open = formid.split("/");
					viewer.getPdf(open[1]);
					// loadFrom("skjema_page", 0, open[1])
					return;
				}

				if (formid === "login") {
					return skjemaLogin(viewer, location.href);
				}

				if (formid === "mine" || formid === "minside") {
					testlogin(user, viewer);
					return skjemaOverview2(viewer);
				}

				loadFrom("skjema_page", formid);
			});
		});
};

export const loadFrom = (containerid, formid, refid) => {
	const formlink = generateFormsUrl();

	const config = {
		divId: containerid,
		onSubmitted: (receipt) => {
			$(`#${containerid}`).html(`
                    ${language("FORM_RECEIVED_FEEDBACK", receipt.refId)}
                                <div id="receivedform_info">
                                </div>
                            `);

		},
		onAborted: () => {
			const minsideLink = window.serverdata.configMeta.aim?.mysite?.link ?? '/minside';
			const link = window.serverdata.configMeta.aim?.mysite?.forms?.skjema ? `${minsideLink}?page=forms` : "/skjema/mine";
			$(`#${containerid}`).html(
				`${language("FORM_CANCELED")}
						<p>
								<a href="${link}">${language("FORM_GOTO_MYFORMS")}</a>
						</p>`,
			);
		},
		onSaved: (savedData) => {
			const minsideLink = window.serverdata.configMeta.aim?.mysite?.link ?? '/minside';
			const link = window.serverdata.configMeta.aim?.mysite?.forms?.skjema ? `${minsideLink}?page=forms` : "/skjema/mine";
			$(`#${containerid}`).html(`
        ${language("FORM_SAVED")}
            <a href="${link}">${language("FORM_MYFORMS")}</a>
             <div id="receivedform_info"></div>`
			);
		},
	};

	// console.log("config", config);

	if (formid) {
		config.formId = formid;
	}
	if (refid) {
		config.refId = refid;
	}

	viewer.form(config);
};

export const skjemaLink = (content) => {
	const formlink = generateFormsUrl();
	const target =
		detectMob() && window.serverdata.configMeta.aim?.skjema?.targetMobile
			? `target="${window.serverdata.configMeta.aim.skjema.targetMobile}" `
			: window.serverdata.configMeta.aim?.skjema?.target
				? `target="${window.serverdata.configMeta.aim.skjema.target}" `
				: "";

	const regex = /href="(aim:skjema:|\/artikkel\/skjema:|skjema:)/gim;

	if (content.match(regex)) {
		return content.replace(regex, `${target}data-changedurl="skjema" href="${formlink}`);
	}

	if (content.match(/\/skjema\/[0-9]{1,10}$/gim)) {
		return content.replace(/\/skjema\/[0-9]{1,10}$/gim, formlink);
	}

	return content;
};

export const skjemaInline = () => {
	const formid = $("#inline-skjema").data("skjemaid");

	if ($("#inline-skjema").length > 0) {
		loadFrom("inline-skjema", formid);
	}
};

function generateFormsUrl () {
	const skjemaUrl = window.serverdata.configMeta.aim?.skjema?.url ? window.serverdata.configMeta.aim.skjema.url : "/skjema/";
	const skjemaClient = window.serverdata.configMeta.aim?.skjema?.id ? window.serverdata.configMeta.aim?.skjema?.id : window.serverdata.configMeta.aim.nameId;
	const skjemaUrlMobile = window.serverdata.configMeta.aim?.skjema?.urlMobile ? window.serverdata.configMeta.aim.skjema.urlMobile : `https://skjema.no/${skjemaClient}/`;

	return detectMob() ? skjemaUrlMobile : skjemaUrl;
}

function detectMob () {
	const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

	return toMatch.some((toMatchItem) => {
		return navigator.userAgent.match(toMatchItem);
	});
}
